import { type IFeeDto } from '../types/response';

export interface IFeeGroup {
  billNumber: string | null;
  invoiceDate: string | null;
  receiptNumber: string | null;
  paymentDate: string | null;
  fees: IFeeDto[];
}

function groupByBillNumber(fees: IFeeDto[]) {
  const groupedFees: Record<string, IFeeGroup> = {};

  structuredClone(fees)
    .reverse()
    .forEach((fee) => {
      const key = fee.billNumber || 'empty';

      if (!groupedFees[key]) {
        const { billNumber, invoiceDate, receiptNumber, paymentDate } = fee;
        groupedFees[key] = {
          billNumber,
          invoiceDate,
          receiptNumber,
          paymentDate,
          fees: [fee],
        };
      } else {
        groupedFees[key]!.fees.push(fee);
      }
    });

  return Object.values(groupedFees);
}

export default groupByBillNumber;
